import { useContext, useEffect } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import SelectControl from "./SelectControl";
import { USStateFieldOptions } from "wvus-forms";
import { validators } from "../../languages";
import MainStateContext from "../../state/mainStateContext";

export function StateField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  const { setValueChange } = formMethods;
  const { state } = useContext(MainStateContext);
  const { address } = state;

  useEffect(() => {
    setValueChange("state", address.state);
  }, [address.state]);

  return (
    <SelectControl
      fieldId="state"
      fieldName="state"
      fieldTitlePhraseKey="payment_step.field_labels.state"
      fieldType="text"
      fieldValue={address.state}
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required sr-only"}
      fieldOptions={USStateFieldOptions}
      formMethods={formMethods}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      attributes={{
        disabled: disabled
      }}
      validators={[validators.required, validators.invalidChars, validators.maxLength(150)]}
    />
  );
}

export default StateField;
